export default {
    initMap() {
            const lt = {lat: 55.169437, lng: 23.881275};
            const vilnius = {lat: 55.169437, lng: 23.881275};
            const kaunas = {lat: 55.169437, lng: 23.881275};
            const klaipeda = {lat: 55.703297, lng: 21.144279};
            const panavezys = {lat: 55.169437, lng: 23.881275};
            const siauliai = {lat: 55.169437, lng: 23.881275};

            const map = new google.maps.Map(document.getElementById("map"), {
                zoom: 7.2,
                center: lt,
            });
    }
}